"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelVariantProps = exports.labelStyles = exports.FormLabelLabel = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _spacing = require("../../../constants/spacing");
var _typography = require("../../typography");
const labelVariantProps = {
  oldestar: {
    system: "lodestar",
    variant: "bodyStrong"
  },
  "lodestar-light": {
    system: "lodestar",
    variant: "bodyStrong"
  },
  "ursa-light": {
    system: "ursa",
    variant: "Inter--12px--600w"
  }
};
exports.labelVariantProps = labelVariantProps;
const labelStyles = (0, _sdsThemeInternal.themed)({
  color: {
    rest: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default"),
      "ursa-light": (0, _designTokensReact.color)("color--text--neutral--strong")
    },
    error: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--error--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--text--neutral--strong")
    }
  },
  margin: {
    "lodestar-light": _spacing.sizes.xSmall,
    "ursa-light": _spacing.sizes.xxSmall
  }
});
exports.labelStyles = labelStyles;
const FormLabelLabel = (0, _styled.default)(_typography.TypeRampV2)`
    display: flex;
    margin-bottom: ${_ref => {
  let {
    themeMode
  } = _ref;
  return labelStyles.margin(themeMode);
}}px;
    color: ${_ref2 => {
  let {
    themeMode,
    validationState
  } = _ref2;
  return validationState === "error" ? labelStyles.color.error(themeMode) : labelStyles.color.rest(themeMode);
}};
`;
exports.FormLabelLabel = FormLabelLabel;
//# sourceMappingURL=FormLabelLabel.js.map